import { render, staticRenderFns } from "./SubjectEdit.vue?vue&type=template&id=c96dde90&"
import script from "./SubjectEdit.vue?vue&type=script&lang=js&"
export * from "./SubjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports